<template>
    <sub-section title="Do it yourself, guidance, or advice?" :showHelp="false">
        <p class="mb-3">
            You can choose to do things yourself, get advice or use a guidance based option.
        </p>

        <div class="d-flex flex-column flex-md-row gap-3 mb-3">
            <div class="flex-fill w-100 d-flex flex-column">
                <div class="header p-2 text-center">Do it yourself</div>
                <div class="flex-grow-1 description p-3">
                    <p>Use a DIY provider and manage your plan payments yourself.</p>
                    <p>Offers a very wide range of funds and investment options to construct an investment portfolio yourself.</p>
                    <p class="fw-bold">Offered by many pension providers in the market.</p>
                    <p>Examples shown if you click 'Do it Yourself' below.</p>
                </div>
                <div class="mt-3 p-2">
                    <button class="btn btn-secondary btn-option w-100" @click="handleClick('DIY')">Do it yourself</button>
                </div>
            </div>
            <div class="flex-fill w-100 d-flex flex-column">
                <div class="header p-2 text-center">Guidance based</div>
                <div class="flex-grow-1 description p-3">
                    <p>Use a provider to put your plan payments in place with on an automated basis with a simple, limited range of funds for you to choose from.</p>
                    <p>Receive the monthly plan payments as wanted with the ability for you to check and review the progress of your plan yourself over time.</p>
                    <p class="fw-bold">Offered by Pathlines with support from Guiide</p>
                    <p>More info shown if you click Guidance below.</p>
                </div>
                <div class="mt-3 p-2">
                    <button class="btn btn-secondary btn-option w-100" @click="handleClick('Guidance')">Guidance</button>
                </div>
            </div>
            <div class="flex-fill w-100 d-flex flex-column">
                <div class="header p-2 text-center">Get advice</div>
                <div class="flex-grow-1 description p-3">
                    <p>Take your plan to an adviser to recommend a suitable provider and investments.</p>
                    <p>Needed if you want a clear recommendation on a provider to choose, or which investment strategy is suitable for you. Can also include annual advice reviews if wanted.</p>
                    <p class="fw-bold">Offered by many advisers in the market.</p>
                    <p>Examples shown if you click Advice below.</p>
                </div>
                <div class="mt-3 p-2">
                    <button class="btn btn-secondary btn-option w-100" @click="handleClick('Advice')">Advice</button>
                </div>
            </div>
        </div>

        <p class="mt-5 fw-bold">
            Commercial disclosures
        </p>
        <p>If you choose the DIY provider route - Guiide receives no payments from any DIY provider shown. Guiide does have some commercial licensing relationships with some providers shown.</p>
        <p>If you choose the Guidance based route - Guiide will receive ongoing payments from Pathlines. These are paid to Guiide from the Pathlines product fee. Given the integration with Guiide plan payments, this product is only available via Guiide.</p>
        <p>If you choose Advice - Guiide may receive one off referral fees from any adviser shown.</p>
        <p>There are a wide range of alternative providers and advisers on the market. You can use your Guiide plan with any provider or adviser you choose. There is no restriction on doing this and our modelling tools remain available to everyone.</p>
    </sub-section>
</template>

<script setup lang="ts">
import SubSection from '../common/SubSection.vue';

type OptionType = 'DIY' | 'Guidance' | 'Advice';

const emit = defineEmits<{(e: 'detail-requested', option: OptionType): void;}>();

function handleClick(option: OptionType) {
  window.scrollTo({ top: 0, behavior: 'auto' });
  emit('detail-requested', option);
}
</script>

<style scoped>
.header {
    color: white !important;
    background-color: #3e566e;
    font-family: "Montserrat", "Helvetica Neue Light", "Helvetica Neue", Helvetica, "Lato", Arial, sans-serif !important;
    font-size: 14px;
    font-weight: 700;
}

.description {
    background-color: #E8F5F5;
}

.cost {
    font-family: "Montserrat", "Helvetica Neue Light", "Helvetica Neue", Helvetica, "Lato", Arial, sans-serif !important;
    font-size: 14px;
    font-weight: 700;
}

.btn-option {
    background-color: #3e566e !important;
    border-color: black !important;
    color: white !important;
    font-weight: 500;
}

.btn-guidance {
    background-color: #DB7E2B !important;
    border-color: #DB7E2B !important;
    color: #fff !important;
    font-weight: 700;
}

.btn-advice {
    background-color: #AC4F37 !important;
    border-color: #AC4F37 !important;
    color: #fff !important;
    font-weight: 700;
}
</style>